export default {
  global: {
    loc_country_data: {
      rs: {
        city_data: [
          "rs_001",
          "rs_002",
          "rs_003",
          "rs_004",
          "rs_005",
          "rs_006",
          "rs_007",
          "rs_008",
          "rs_009",
          "rs_010",
          "rs_011",
          "rs_012",
          "rs_013",
          "rs_014",
          "rs_015",
          "rs_016",
          "rs_017",
          "rs_018",
          "rs_019",
          "rs_020",
          "rs_021",
          "rs_022",
          "rs_023",
          "rs_024",
          "rs_025",
          "rs_026",
          "rs_027",
          "rs_028",
          "rs_029",
          "rs_030",
          "rs_031",
          "rs_032",
          "rs_033",
          "rs_034",
          "rs_035",
          "rs_036",
          "rs_037",
          "rs_038",
          "rs_039",
          "rs_040",
          "rs_041",
          "rs_042",
        ],
        city_value: "rs_002",
      },
    },
  },
};
